import React from 'react';

import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';

import './pagination.css'
const propTypes = {
  onChangePage: PropTypes.func.isRequired,
  totalPageCount: PropTypes.number,
  initialPage: PropTypes.number,
  pageSize: PropTypes.number,
  selectedPage: PropTypes.number
};

const defaultProps = {
  initialPage: 1,
  pageSize: 5
};

class PaginationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pager: {} };
    console.log('pagination')
  }

  componentDidMount() {
    if (this.props.totalPageCount) {

      this.setPage(parseInt(this.props.selectedPage));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedPage !== prevProps.selectedPage) {
      this.setPageChange(parseInt(this.props.selectedPage));
    }
  }
  setPage(page) {
    var { pageSize } = this.props;
    var pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    pager = this.getPager(page, pageSize);

    this.setState({ pager: pager });
  }

  setPageChange(page) {
    this.setPage(page);
    this.props.onChangePage(page);
  }

  getPager(currentPage, pageSize) {
    currentPage = currentPage || 1;

    var totalPages = this.props.totalPageCount // Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, this.props.totalPageCount);

    var pages = [...Array(endPage + 1 - startPage).keys()].map(
      i => startPage + i
    );

    return {
      // totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

  render() {
    var pager = this.state.pager;
    // console.log('PAGER >> ', pager);
    if (!pager.pages || pager.pages.length <= 1) {
      return null;
    }

    return (
      <Pagination
        className='pagination-component d-flex justify-content-between marginTop20'
        variant='outline-primary'
      >
        <div className="d-flex">

        <Pagination.First
          className={pager.currentPage === 1 ? 'disabled' : ''}
          onClick={() => this.setPageChange(1)}
        >
          {'<<'}
        </Pagination.First>
        <Pagination.Prev
          className={pager.currentPage === 1 ? 'disabled' : ''}
          onClick={() => this.setPageChange(pager.currentPage - 1)}
        >
          {'<'}
        </Pagination.Prev>
        </div>
        <div className="d-flex">
        {pager.pages.map((page, index) => (
          <Pagination.Item
            key={index}
            className={pager.currentPage === page ? 'active' : ''}
            onClick={() => this.setPageChange(page)}
          >
            {page}
          </Pagination.Item>
        ))}
        </div>
        <div className="d-flex">

        <Pagination.Next
          className={pager.currentPage === pager.totalPages ? 'disabled' : ''}
          onClick={() => this.setPageChange(pager.currentPage + 1)}
        >
          {'>'}
        </Pagination.Next>
        <Pagination.Last
          className={pager.currentPage === pager.totalPages ? 'disabled' : ''}
          onClick={() => this.setPageChange(pager.totalPages)}
        >
          {'>>'}
        </Pagination.Last>
        </div>
      </Pagination>
    );
  }
}

PaginationComponent.propTypes = propTypes;
PaginationComponent.defaultProps = defaultProps;
export default PaginationComponent;
